import _awaitAsyncGenerator from "@babel/runtime/helpers/awaitAsyncGenerator";
import _wrapAsyncGenerator from "@babel/runtime/helpers/wrapAsyncGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import Phase from '../constants/phase';
import bindActionType from './bind-action-type';
import validateActionType from './validate-action-type';
export default function createAsyncAction(actionType, effect) {
  validateActionType(actionType);

  function createAsyncAction(_x) {
    return _createAsyncAction.apply(this, arguments);
  }

  function _createAsyncAction() {
    _createAsyncAction = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
      var optimistic, payload;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              optimistic = {
                phase: Phase.Optimistic
              };
              _context.next = 3;
              return input === undefined ? {
                type: actionType,
                meta: optimistic
              } : {
                type: actionType,
                payload: input,
                meta: optimistic
              };

            case 3:
              _context.prev = 3;
              _context.next = 6;
              return _awaitAsyncGenerator(effect(input));

            case 6:
              payload = _context.sent;
              _context.next = 9;
              return {
                type: actionType,
                payload: payload
              };

            case 9:
              return _context.abrupt("return", payload);

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);
              _context.next = 16;
              return {
                type: actionType,
                error: true,
                payload: _context.t0
              };

            case 16:
              throw _context.t0;

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 12]]);
    }));
    return _createAsyncAction.apply(this, arguments);
  }

  return bindActionType(actionType, createAsyncAction);
}